export var createWrapChannelMergerNode = function createWrapChannelMergerNode(createInvalidStateError, monitorConnectionsFunction) {
  return function (nativeContext, channelMergerNode) {
    channelMergerNode.channelCount = 1;
    channelMergerNode.channelCountMode = 'explicit';
    Object.defineProperty(channelMergerNode, 'channelCount', {
      get: function get() {
        return 1;
      },
      set: function set() {
        throw createInvalidStateError();
      }
    });
    Object.defineProperty(channelMergerNode, 'channelCountMode', {
      get: function get() {
        return 'explicit';
      },
      set: function set() {
        throw createInvalidStateError();
      }
    }); // Bug #20: Safari requires a connection of any kind to treat the input signal correctly.

    var audioBufferSourceNode = nativeContext.createBufferSource();

    var whenConnected = function whenConnected() {
      var length = channelMergerNode.numberOfInputs;

      for (var i = 0; i < length; i += 1) {
        audioBufferSourceNode.connect(channelMergerNode, 0, i);
      }
    };

    var whenDisconnected = function whenDisconnected() {
      return audioBufferSourceNode.disconnect(channelMergerNode);
    };

    monitorConnectionsFunction(channelMergerNode, whenConnected, whenDisconnected);
  };
};